import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CloudOff from '@mui/icons-material/CloudOff';
import { ChapterList, Message } from 'components';
import FlashcardListItem from './FlashcardListItem';
import { UserContentValuesContext, NetworkStatusValuesContext } from 'contexts';

const StyledBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  overflowY: 'auto',
  overflowX: 'hidden',
  width: '100%',
  maxWidth: '100%',
}));

const messageProps = {
  text: `You're currently offline. Links to content that have not been downloaded are unavailable. Once you're online, your flashcards will automatically sync.`,
  icon: <CloudOff />,
  shouldHaveAction: false,
  shouldHaveBorderRadius: false,
};

const FlashcardsMenu = ({ ...props }) => {
  const userContent = useContext(UserContentValuesContext);
  const { isOffline } = useContext(NetworkStatusValuesContext);

  const flashcardsByDeckList = userContent?.flashcardsByDeck;

  return (
    <StyledBox {...props}>
      {isOffline ? <Message {...messageProps} /> : null}
      {flashcardsByDeckList ? (
        <ChapterList>
          {flashcardsByDeckList.map(([key, value]) => (
            <FlashcardListItem
              isOffline={isOffline}
              key={key ? key.key : 'no-chapter'}
              deck={key}
            >
              {value}
            </FlashcardListItem>
          ))}
        </ChapterList>
      ) : null}
    </StyledBox>
  );
};

FlashcardsMenu.defaultProps = {
  width: 256,
};

export default FlashcardsMenu;
